/* eslint-disable max-len */
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { FilterAndSortField as MyNetworkClientsFilterAndSortField } from '@1po/1po-bff-fe-spec/generated/my_network/request/model/FilterAndSortField';
import {
  getMyNetworkClientsFilters,
  resetMyNetworkClientsFilterAndSort,
  setMyNetworkClientsFilter,
} from 'domains/r1Network/R1Network.store';
import { MyNetworkClientsFilterField } from 'domains/r1Network/R1Network.types';
import { FilterInputField } from 'pages/MyOrdersPage/ClientsOrders/Filter/components/FilterInputField';
import { Flex, Text } from 'UI';

export const MyNetworkFilter = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const filters = useSelector(getMyNetworkClientsFilters);

  const updateFilters = useCallback(
    (field: MyNetworkClientsFilterAndSortField, value: string, validate = false) => {
      if (validate && value && value.length <= 2) {
        return;
      }
      dispatch(setMyNetworkClientsFilter({ field, value }));
    },
    [dispatch],
  );

  return (
    <Flex direction={'column'} gap={15} align={'flex-end'}>
      <Flex gap={15} wrap={'wrap'}>
        <FilterInputField
          value={filters.get(MyNetworkClientsFilterField.COMPANY_NAME)}
          placeholder={t('my_network.clients.filter.company_name', 'Company name')}
          onChangeDebounced={(value) => updateFilters(MyNetworkClientsFilterField.COMPANY_NAME, value, true)}
        />
        <FilterInputField
          value={filters.get(MyNetworkClientsFilterField.BILLING_ACCOUNT)}
          placeholder={t('my_network.clients.filter.billing_account', 'Billing account')}
          onChangeDebounced={(value) => updateFilters(MyNetworkClientsFilterField.BILLING_ACCOUNT, value, true)}
        />
        <FilterInputField
          value={filters.get(MyNetworkClientsFilterField.TRESOR_CODE)}
          placeholder={t('my_network.clients.filter.tresor_code', 'Tresor code')}
          onChangeDebounced={(value) => updateFilters(MyNetworkClientsFilterField.TRESOR_CODE, value, true)}
        />
        <Flex align={'center'} size={0}>
          <Text
            type="heading5"
            color="white"
            displayStyle={'link'}
            disableGutter
            hoverUnderLine
            noWrap
            cursor={'pointer'}
            onClick={() => {
              dispatch(resetMyNetworkClientsFilterAndSort());
            }}
          >
            {t('common.action.reset_filters', 'Reset filters')}
          </Text>
        </Flex>
      </Flex>
    </Flex>
  );
};
